import OrderConfirmPage from './OrderConfirmPage';

export default OrderConfirmPage;



// WEBPACK FOOTER //
// ./src/containers/OrderConfirmPage/index.js